/**
 * Returns true if the given hex color is perceived as light (suitable for dark text).
 * Uses relative luminance formula: (0.299*R + 0.587*G + 0.114*B) / 1000 > 128
 */
export function isLight(hex: string): boolean {
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 128;
}
